import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col gap-10 bg-gray-utility-50 p-8 [&_.bg-gray-utility-50]:bg-gray-light-25',
});

const gridClasses = cva({
  base: ['grid gap-x-8 gap-y-4', 'grid-cols-[repeat(auto-fill,118px)]'],
});

const dividerClasses = cva({
  base: 'w-px min-h-[163px] shrink-0 bg-[#D5D7DA]',
});

const noExtraAssetsClasses = cva({
  base: ['flex items-center gap-6 p-6', 'bg-success-25 border border-solid border-success-primary/40'],
});

const noExtraAssetsIconClasses = cva({
  base: [
    'h-fit w-fit shrink-0 p-1 rounded-full',
    'border border-solid border-success-primary/30 text-success-600',
    'outline outline-offset-2 outline-success-600/10',
  ],
});

export { containerClasses, dividerClasses, gridClasses, noExtraAssetsClasses, noExtraAssetsIconClasses };
